"use client";

import React, { useState } from "react";
import { NodeViewWrapper, NodeViewContent } from "@tiptap/react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";

interface CodeBlockComponentProps {
  node: any;
  readOnly?: boolean;
}

export function CodeBlockComponent({
  node,
  readOnly = false,
}: CodeBlockComponentProps) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    const codeContent = node.textContent || "";

    if (codeContent) {
      try {
        await navigator.clipboard.writeText(codeContent);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch (err) {
        console.error("Failed to copy:", err);
      }
    }
  };

  return (
    <NodeViewWrapper className="tiptap-code-block-wrapper">
      <Button
        variant="outline"
        size="sm"
        className="code-copy-button"
        onClick={copyToClipboard}
        type="button"
      >
        {copied ? (
          <>
            <Check className="size-4 mr-1 text-secondary-500" />
            Copied!
          </>
        ) : (
          <>Copy to Clipboard</>
        )}
      </Button>
      <pre>
        <code>
          <NodeViewContent />
        </code>
      </pre>
    </NodeViewWrapper>
  );
}
